import React from 'react';
import { Upload, Database, Activity } from 'lucide-react';

const steps = [
  {
    icon: Upload,
    step: '01',
    title: 'Secure Lease Ingestion',
    description: 'Upload files or connect shared folders.',
  },
  {
    icon: Database,
    step: '02',
    title: 'Structured Extraction',
    description: 'Options and CAM terms abstracted into standardized data.',
  },
  {
    icon: Activity,
    step: '03',
    title: 'Ongoing Monitoring',
    description: 'Track windows, expirations, and exposure in real time.',
  },
];

export function HowItWorksSection(): JSX.Element {
  return (
    <section id='how-it-works' className='py-24 md:py-32'>
      <div className='mx-auto max-w-6xl px-6'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2
            className='text-3xl font-bold tracking-tight text-foreground md:text-4xl text-balance'
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            How It Works
          </h2>
        </div>

        <div className='relative mt-16 grid gap-8 md:grid-cols-3'>
          {/* Connector line (desktop) */}
          <div className='absolute top-12 left-[16.67%] right-[16.67%] hidden h-px bg-border md:block' aria-hidden='true' />

          {steps.map((s) => (
            <div key={s.step} className='relative flex flex-col items-center text-center'>
              <div className='relative z-10 flex h-24 w-24 items-center justify-center rounded-2xl bg-teal/15 border border-teal/20'>
                <s.icon className='h-8 w-8 text-foreground' />
              </div>

              <span className='mt-6 text-xs font-bold uppercase tracking-widest text-teal-dark'>
                Step
                {' '}
                {s.step}
              </span>

              <h3
                className='mt-3 text-lg font-semibold text-foreground'
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {s.title}
              </h3>

              <p className='mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground'>
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
